import { render, staticRenderFns } from "./DoctorSpecialities.vue?vue&type=template&id=245fb1e5&"
import script from "./DoctorSpecialities.vue?vue&type=script&lang=js&"
export * from "./DoctorSpecialities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports